import { CloseButton } from "@chakra-ui/react";
import React, { useContext } from "react";
import { AppContext } from "../context/app.context";

type Props = {};

const BackButton = (props: Props) => {
  const { goBack } = useContext(AppContext);

  return (
    <CloseButton
      zIndex={999}
      onClick={goBack}
      position="absolute"
      top={2}
      right={2}
    />
  );
};

export default BackButton;
